import React from 'react';
import { FaInstagram, FaApple, FaGooglePlay, FaLinkedin } from 'react-icons/fa';
import Logo from '../assets/logo/Selal_Logo.png';
import { useLang } from '../context/langcontext'; // ✅ import global translator

const Footer = () => {
  const { t } = useLang();

  return (
    <footer>
      <div className="footer-content">
        {/* Logo */}
        <img src={Logo} alt="Selal Logo" className="footer-logo" />

        {/* Tagline */}
        <p className="footer-tagline">{t("heroSubtext")}</p>

        {/* Social Icons */}
        <div className="footer-icons">
          <a
            href="https://www.instagram.com/selal_aap?igsh=YnlsMmQ2NDhqbWVk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://apps.apple.com/om/app/selal/id6596748079"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaApple />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.selal.app&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGooglePlay />
          </a>
          <a
            href="https://www.linkedin.com/company/selal-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          &copy; 2025 Selal. {t("footerRights")} | Website by{" "}
          <a
            href="https://technovia-agency.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-credit"
          >
            Technovia
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
